
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';
import { ReportsSortableHeader } from './ReportsSortableHeader';

interface ReportTableHeaderProps {
  showTeacherDisplay: boolean;
  showAdminColumns: boolean;
  sortField: string;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
}

export const ReportTableHeader: React.FC<ReportTableHeaderProps> = ({ 
  showTeacherDisplay, 
  showAdminColumns,
  sortField,
  sortDirection,
  onSort
}) => {
  const { t } = useTranslation();
  return (
    <TableHeader>
      <TableRow>
        <ReportsSortableHeader 
          field="teaching_date"
          label={t('reports.table.teachingDate')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <ReportsSortableHeader 
          field="teaching_time_slot"
          label={t('reports.table.teachingTime')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <ReportsSortableHeader 
          field="student_nickname"
          label={t('reports.table.studentName')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        {showTeacherDisplay && <ReportsSortableHeader 
          field="teacher_display"
          label={t('reports.table.teacher')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />}
        <ReportsSortableHeader 
          field="status"
          label={t('reports.table.status')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        {showAdminColumns && <ReportsSortableHeader 
          field="learning_status"
          label={t('reports.table.learningStatus')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />}
        {showAdminColumns && <ReportsSortableHeader 
          field="teaching_content"
          label={t('reports.table.topic')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />}
        {showAdminColumns && <TableHead className="text-center">{t('reports.table.submittedOnTime')}</TableHead>}
        {showAdminColumns && <TableHead className="text-center">{t('reports.table.hoursDeducted')}</TableHead>}
        <ReportsSortableHeader 
          field="created_at"
          label={t('reports.table.createdAt')}
          currentSortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableHead className="text-right">{t('reports.table.actions')}</TableHead>
      </TableRow>
    </TableHeader>
  );
};
